import { api } from "../../../../../utility/AxiosInceptor";
import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Card } from "primereact/card";
import { Calendar } from "primereact/calendar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import { ToastContainer, toast } from "react-toastify";
import { Parser } from "json2csv";
import "react-toastify/dist/ReactToastify.css";

const Inventory_Download = () => {
  // -------------------- STATE --------------------
  const [apiData, setApiData] = useState([]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [status, setStatus] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [inventoryTypes, setInventoryTypes] = useState([]);
  const [billingModel, setBillingModel] = useState("");
  const [model, setModel] = useState("");

  // Predefined status options
  const statusValue = [
    { name: "Free", value: "Free" },
    { name: "inUse", value: "inUse" },
  ];

  // Get logged-in user info
  const serviceProvider = localStorage.getItem("userData");
  const userData = JSON.parse(serviceProvider);

  // -------------------- API CALLS --------------------

  // 1. Fetch inventory data (filters applied)
  useEffect(() => {
    const fetchData = async () => {
      const formattedDateFrom = dateFrom
        ? new Date(dateFrom).toISOString().slice(0, 19)
        : "";
      const formattedDateTo = dateTo
        ? new Date(dateTo).toISOString().slice(0, 19)
        : "";

      try {
        const requestData = {
          startDate: formattedDateFrom,
          endDate: formattedDateTo,
          billingModel: model,
          inventoryType: inventory,
          status: status,
        };

        const response = await api.post(
          `/api/web/inventoryDownloads/getInventory`,
          requestData
        );

        if (response?.status === 200 || response?.status === 201) {
          setApiData(response?.data?.simsData);
        }
      } catch (error) {
        toast.error(error?.response?.data?.error);
      }
    };

    fetchData();
  }, [dateFrom, dateTo, model, inventory, status]);

  // 2. Fetch inventory type options
  useEffect(() => {
    const inventoryTypeData = async () => {
      try {
        const response = await api.get(
          `/api/inventoryType/all?serviceProvider=${userData?.company}`
        );
        setInventoryTypes(response?.data?.data);
      } catch (error) {
        // handle error silently
      }
    };

    inventoryTypeData();
  }, [userData.company]);

  // 3. Fetch billing model options
  useEffect(() => {
    const fetchBillingModels = async () => {
      try {
        const response = await api.get(
          `/api/billingModel/all?serviceProvider=${userData?.company}`
        );
        setBillingModel(response?.data?.data);
      } catch (error) {
        // handle error silently
      }
    };

    fetchBillingModels();
  }, [userData.company]);

  // -------------------- HELPERS --------------------

  // Download CSV file
  const handleDownload = () => {
    const apiDataFormatted = apiData.map((item) => ({
      ...item,
      esnNumber: String(item.esnNumber), // ensure ESN number is string
    }));

    const fields = ["billingModel", "InventoryType", "status", "esnNumber"];
    const json2csvParser = new Parser({ fields });
    const csv = json2csvParser.parse(apiDataFormatted);

    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "inventory_data.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // -------------------- UI --------------------
  return (
    <>
      <ToastContainer />
      <Card className="pl-0 pr-0">
        {/* Header */}
        <div>
          <h1>Inventory Downloads</h1>
        </div>

        {/* Filter Section */}
        <Card style={{ height: "18rem" }}>
          {/* Billing Model */}
          <div
            className="p-field col-12 md:col-3"
            style={{ marginLeft: "7rem" }}
          >
            <label className="Label__Text">Billing Model</label> <br />
            <br />
            <Dropdown
              value={model}
              onChange={(e) => setModel(e.value)}
              options={billingModel}
              optionLabel="billingModel"
              optionValue="billingModel"
              placeholder="Select Model"
              className="w-full md:w-14rem"
            />
          </div>

          {/* Inventory Type */}
          <div
            className="p-field col-12 md:col-3"
            style={{ marginLeft: "25rem", marginTop: "-6.5rem" }}
          >
            <label className="Label__Text">Inventory Type</label>
            <br />
            <br />
            <MultiSelect
              id="inventorySelect"
              value={inventory}
              onChange={(e) => setInventory(e.value)}
              options={inventoryTypes}
              optionLabel="inventoryType"
              display="chip"
              placeholder="Select Inventory"
              maxSelectedLabels={3}
              optionValue="inventoryType"
              className="w-full md:w-20rem"
            />
          </div>

          {/* Status */}
          <div
            className="p-field col-12 md:col-3"
            style={{ marginLeft: "50rem", marginTop: "-6.2rem" }}
          >
            <label className="Label__Text">Status</label>
            <br />
            <br />
            <MultiSelect
              value={status}
              onChange={(e) => setStatus(e.value)}
              options={statusValue}
              optionLabel="name"
              display="chip"
              placeholder="Select Status"
              maxSelectedLabels={3}
              className="w-full md:w-20rem"
            />
          </div>

          {/* Date From */}
          <div
            className="p-field col-12 md:col-3"
            style={{ marginLeft: "7rem", marginTop: "2rem" }}
          >
            <label className="Label__Text">Date From</label>
            <br />
            <br />
            <Calendar value={dateFrom} onChange={(e) => setDateFrom(e.value)} />
          </div>

          {/* Date To */}
          <div
            className="p-field col-12 md:col-3"
            style={{ marginLeft: "25rem", marginTop: "-6.5rem" }}
          >
            <label className="Label__Text">Date To</label>
            <br />
            <br />
            <Calendar value={dateTo} onChange={(e) => setDateTo(e.value)} />
          </div>
        </Card>

        {/* Data Table Section */}
        <div
          className="card"
          style={{ width: "62rem", marginLeft: "5rem", marginTop: "4rem" }}
        >
          <DataTable value={apiData.slice(0, 1)} style={{ width: "50rem" }}>
            <Column field="billingModel" header="Billing Model" />
            <Column field="InventoryType" header="Inventory Type" />
            <Column field="status" header="Status" />
            <Column
              header="Counter"
              body={() => <div>{apiData.length}</div>} // Show total count
            />
            <Column
              field="Action"
              body={() => (
                <Button
                  className="bg-blue-700 pl-2 pr-2 pt-1 pb-1 border-none"
                  onClick={handleDownload}
                >
                  Download
                </Button>
              )}
            />
          </DataTable>
        </div>
      </Card>
    </>
  );
};

export default Inventory_Download;
